import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { viewerApi } from 'src/api';

export const fetchViewers = createAsyncThunk('viewer/fetch-viewers', async (data, thunkApi) => {
  try {
    const response = await viewerApi.fetchViewers(data);

    return response.data;
  } catch (error) {
    console.error('fetchViewers[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});
